import { objectWithoutPropertiesLoose as _objectWithoutPropertiesLoose } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import React__default from 'react';
import { useProxiedRef } from '../../../utils/hooks/useProxiedRef.js';
import { Pagination } from '../../Pagination/Pagination.js';
import { useTable } from '../hooks/useTable.js';
import { Row } from '../util/renderRow.js';
import { BaseTable, DefaultEmptyState } from './BaseTable.js';

var _excluded = ["emptyStateRenderer"];
var Table = /*#__PURE__*/React__default.forwardRef(function Table(props, ref) {
  var _props$emptyStateRend = props.emptyStateRenderer,
      emptyStateRenderer = _props$emptyStateRend === void 0 ? DefaultEmptyState : _props$emptyStateRend,
      otherProps = _objectWithoutPropertiesLoose(props, _excluded);

  var tableRef = useProxiedRef(ref);

  var _useTable = useTable(otherProps, tableRef),
      rowProps = _useTable.rowProps,
      tableProps = _useTable.tableProps,
      rows = _useTable.rows,
      prepareRow = _useTable.prepareRow,
      pagination = _useTable.pagination,
      instance = _useTable.instance;

  var paginationElement;

  if (pagination) {
    paginationElement = React__default.createElement(Pagination, {
      className: "my-4 w-full",
      length: pagination.length,
      pageIndex: pagination.pageIndex,
      pageSize: pagination.pageSize,
      setPageIndex: pagination.setPageIndex,
      setPageSize: pagination.setPageSize,
      showPageControls: pagination.length > pagination.pageSize,
      dangerouslyHijackGlobalKeyboardNavigation: props.dangerouslyHijackGlobalKeyboardNavigation
    });
  }

  return React__default.createElement(React__default.Fragment, null, paginationElement, React__default.createElement(BaseTable, Object.assign({}, tableProps, {
    ref: tableRef,
    tabIndex: 0
  }), rows.length ? rows.map(function (row, index) {
    prepareRow(row, index);
    return React__default.createElement(Row, Object.assign({}, rowProps, {
      key: index,
      index: index,
      row: row,
      instance: instance,
      headerGroups: tableProps.headerGroups
    }));
  }) : emptyStateRenderer()), paginationElement);
});

Table.Column = function () {
  return null;
};

Table.Group = function () {
  return null;
};

export { Table };
//# sourceMappingURL=Table.js.map
